import React, { Component } from 'react';
import SeriesTable from "../../../components/common/SeriesTable";

class OtherDocuments extends Component {
    render() {
        return (
            <div className="panel-body">
                <h2>Empleados</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.employeesSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
                <h2>Almacenes</h2>
                <div className="row">
                    <div className="col">
                        <SeriesTable
                            series={this.props.warehousesSeries}
                            openModal={this.props.openModal}
                        />
                    </div>
                </div>
            </div>
        );
    }
}


export default OtherDocuments;


// WEBPACK FOOTER //
// ./src/containers/configuration/documents/OtherDocuments.js